<!-- 首页 -->
<template>
  <div class="cgh-view">
    <div class="cgh-head">
      <Search
        shape="round"
        show-action
        background="#FF5601"
        placeholder="搜索商品"
        :disabled="true"
        @click="search"
      >
        <template #action>
          <div v-if="!isLogin" @click="login('/login')">登录</div>
          <div v-if="isLogin" @click="login('/userInfo')">
            <img class="cgh-login-ck" src="@/assets/images/loginCk.png" />
          </div>
        </template>
      </Search>
    </div>
    <div class="cgh-content">
      <!-- 广告 -->
      <div class="cgh-banner">
        <swipe :autoplay="3000">
          <SwipeItem v-for="(v, index) in bannerList" :key="index">
            <img @click="imgPreview(index)" v-lazy="v.imageUrl" />
          </SwipeItem>
        </swipe>
      </div>
      <!-- 分类 -->
      <div class="cgh-category" v-show="categoryList.length > 0">
        <div
          class="category-item"
          v-for="(v, index) in categoryList"
          :key="index"
          @click="selClassType(v.id)"
        >
          <div class="img" :id="'img' + index">
            <img v-lazy="v.imageUrl" />
          </div>
          <div class="name">{{v.name}}</div>
        </div>
      </div>
      <div class="cgh-line-bac"></div>
      <!-- 精品推荐 -->
      <div class="cgh-recommend-title">
        <span>精品推荐</span>
      </div>
      <div class="cgh-goods">
        <List
          v-show="goodsList.length != 0"
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="_getList"
        >
          <cghGoodsItem :list="goodsList"></cghGoodsItem>
        </List>
        <Empty v-show="goodsList.length == 0" description="空空如也~" />
      </div>
    </div>
    <cghTab></cghTab>
  </div>
</template>

<script>
import cghTab from "@/components/tab/tab";
import cghGoodsItem from "@/components/cghGoodsItem/cghGoodsItem";
import { Search, List, Toast, Empty, Notify } from "vant";
import { Swipe, SwipeItem, ImagePreview } from "vant";
import { createBaseGoodsExperience } from "@/assets/js/base-goods-spu.js";
import { meetNull } from "@/assets/js/validator.js";
import { mapMutations, mapState } from "vuex";
const posts = require("@/assets/mode/post.json");
const defaultHead = require('@/assets/images/extentIcon/extentIcon2.png');
import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      bannerList: [],
      categoryList: [],
      goodsList: [],
      isLogin: false,
      fromId: "",
      visible: false,
      // 分页
      loading: false,
      finished: false,
      pages: 0, // 总页数
      page: 0, // 当前页数
      pageSize: 10, // 每页大小
    };
  },
  created() {
    this._getBaseInfo();
    let userInfo = localStorage.getItem("qrtMallUser");
    if (meetNull(userInfo)) {
      this.isLogin = true;
    }
    this._getList();
    this.share();
    this.getAuthInfo();
    this.buildFromId();
  },
  methods: {
    ...mapMutations(["changeNoReadMsgLocal", "changeSocketClientIdLocal"]),
    getAuthInfo() {
      // 微信授权/登录
      if (!this.$UTILS.isWeixn()) {
        // 判断是否是微信
        return;
      }
      let userInfo = localStorage.getItem("qrtMallUser");
      let serveToken = this.$UTILS.getQueryString("token");
      let fromId = this.$UTILS.getQueryString("fromid"); //  分享人id
      if (meetNull(userInfo)) { // 账号密码登录状态
        userInfo = JSON.parse(userInfo);
        let openidUpdate = +userInfo.openid_update; // openid是否更新 1表示已更新
        if (openidUpdate != 1) { // openid未更新
          this.memberGet(userInfo.token, fromId);
        }
      } else if (meetNull(serveToken)) { // 获取用户信息
        this.memberGet(serveToken, fromId);
      } 
    },
    authOpenid(token, from) {
      // 用户授权获取openid
      let para = {targetUrl: '/#/home'};
      if (meetNull(token)) {
        para.token = token;
      }
      if (meetNull(from)) {
         para.encryption_id = from;
      }
      this.$API.get('auth/auth_openid' , para).then(res => { // 用户授权获取后台绑定微信信息，获取成功后再次跳转到后台接口
          if (res.status == 1) {
            window.location.href = res.data.url;
          }
      });
    },
    memberGet (token, fromId) {
      // 获取用户信息
       this.$API.get('member/member_get', {token: token}, 0).then(res => {
          if (res.status == 1) {
            let data = res.data;
            if (data.openid_update != 1) { // 更新openid
               this.authOpenid(token, fromId);
            } else { // 更新本地用户信息
              if (meetNull(data)) {
                this.isLogin = true;
                let img = data.image;
                data.image = img.includes(':') ? img : img ? (this.$IMG + img) : defaultHead;
                localStorage.setItem('qrtMallUser', JSON.stringify(data));
              }
            }
          }
        });
    }, 
    buildFromId() {
      // 绑定分享人id
      this.fromId = this.$UTILS.getQueryString("fromid");
      this.$UTILS.buildFromId(this.fromId);
    },
    search() {
      // 点击头部搜索
      this.$router.push("/search");
    },
    login(url) {
      // 去登录/个人
      this.$router.push(url);
    },
    imgPreview(index) {
      // 预览图片
      let imgs = [];
      for (let i = 0; i < this.bannerList.length; i++) {
        imgs.push(this.bannerList[i].imageUrl);
      }
      ImagePreview({
        images: imgs,
        startPosition: index
      });
    },
    _getBaseInfo() {
      // 获取轮播图
      this.bannerList = [];
      this.$API.post("banner/banner_list").then(res => {
        if (res.status == 1) {
          let list = res.data;
          for (let i = 0; i < list.length; i++) {
            let para = { imageUrl: this.$IMG + list[i] };
            this.bannerList.push(para);
          }
        }
      });
      // 获取分类
      this.$API.post("goods_cate/goods_cate_list", { limit: 4 }).then(res => {
        if (res.status == 1) {
          this.categoryList = res.data;
          for (let i = 0; i < this.categoryList.length; i++)
            this.categoryList[i].imageUrl =
            this.$IMG + this.categoryList[i].image;
        }
      });
    },
    _getList() {
      // 获取数据
      let tost = Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      this.page++;
      let para = { recommand: 1, page: this.page, limit: this.pageSize };
      this.$API.get("goods/goods_list", para).then(res => {
        if (res.status == 1) {
          try {
            let list = createBaseGoodsExperience(res.data.list, this.$IMG);
            this.goodsList = this.goodsList.concat(list);
            this.pages = res.data.count;
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.goodsList.length >= res.data.count) {
              this.finished = true;
            }
          } catch (e) {
            this.finished = true;
          }
        }
        tost.clear();
      });
    },
    toGoodsDetails() {
      // 查看商品详情
      this.$router.push("/goodsDetails");
    },
    selClassType(id) {
      // 查看分类
      this.$router.push({path: "/goods", query: { id: id}});
    },
    share() {
      // 微信分享
      let linkUrl = `${this.$ShareUrl}/#/home`;
      this.$UTILS.share(linkUrl);
    }
  },
  components: {
    cghTab,
    cghGoodsItem,
    Search,
    Swipe,
    SwipeItem,
    List,
    Empty,
  }
};
</script>
<style scoped lang='scss'  >
@import "@/assets/style/minxi.scss";
.cgh-view {
  padding: 50px 0px 20px 0px;
  .cgh-head {
    width: 100%;
    position: fixed;
    top: 0;
    color: white;
    font-size: 12px;
    background: $theremColor;
    z-index: 10;
    .van-search__action {
      color: white;
    }
    .van-icon-manager-o {
      font-size: 22px;
      vertical-align: middle;
    }
    .cgh-login-ck {
      width: 28px;
      height: 28px;
      vertical-align: middle;
    }
  }
  .cgh-content {
    margin-top: 2px;
    // 广告
    .cgh-banner {
      width: 96%;
      margin-left: 2%;
      margin-top: 10px;
      overflow: hidden;
      border-radius: 10px;
      .swipe {
        width: 100%;
        height: 160px;
        border-radius: 10px;
      }
      img {
        width: 100%;
        height: 160px;
        background: orange;
        border-radius: 10px;
        object-fit: fill;
      }
    }
    //分类
    .cgh-category {
      width: 100%;
      margin: 15px 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .category-item {
        order: 1;
        #img0 {
          background: orange;
        }
        #img1 {
          background: #58a3f7;
        }
        #img2 {
          background: #fb8e51;
        }
        #img3 {
          background: #ff6968;
        }
        .img {
          width: 45px;
          height: 45px;
          text-align: center;
          border-radius: 6px;
          margin-left: 4px;
          img {
            width: 35px;
            height: 35px;
            vertical-align: middle;
            margin-top: 5px;
            border-radius: 50%;
          }
        }
        .name {
          color: black;
          text-align: center;
          margin-top: 5px;
          font-size: 14px;
        }
      }
    }
    // 精品推荐
    .cgh-recommend-title {
      width: 100%;
      text-indent: 20px;
      color: black;
      font-weight: bold;
      padding: 15px 0px 10px 0px;
      font-size: 14px;
      span {
        border-bottom: 3px solid red;
        padding-bottom: 5px;
        letter-spacing: 3px;
      }
    }
    .cgh-goods {
      padding-bottom: 30px;
      overflow: hidden;
      min-height: 50px;
    }
  }
}
</style>